import React from "react";
import ProfileHeader from "../profile/ProfileHeader";
import MetricsSection from "../metrics/MetricsSection";
import ActivityCalendar from "../calendar/ActivityCalendar";
import FinancialSummary from "../finance/FinancialSummary";

const DashboardLayout = () => {
  return (
    <div
      className="min-h-sc
    reen bg-gray-50 py-12"
    >
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 gap-8">
          <ProfileHeader />
          <MetricsSection />
          <ActivityCalendar />
          <FinancialSummary />
        </div>
      </main>
    </div>
  );
};

export default DashboardLayout;
